
import LoadMore from 'vux/src/components/load-more/index.vue'

export default {
name: 'page-picker',
components: { LoadMore },
props: {
list: {
type: Array,
default() {
return []
}
},
rows: Number,
type: Number
},
data() {
return {
tip: '点击加载更多',
showloading: false,
curPage: 1
}
},
methods: {
loadmore() {
if (this.tip == '点击加载更多') {
this.showloading = true
this.tip = '正在加载中...'
this.curPage++
setTimeout(() => {
this.$emit('loadlist', this.curPage)
}, 500)
}
}
},
watch: {
list(newVal, oldVal) {
if (newVal.length < oldVal.length) {
if (newVal.length === 0) {
this.curPage = 1
} else {
this.curPage = Math.ceil(newVal.length / this.rows)
}
}
if (newVal.length === this.curPage * this.rows) {
this.tip = '点击加载更多'
} else if (this.curPage == 1 && newVal.length == 0) {
this.tip = '暂无数据'
} else {
this.tip = '数据已加载完'
}
this.showloading = false
},
rows() {
this.curPage = 1
},
type() {
this.curPage = 1
}
}
}
